import {UIStoreBodyController} from './UIStoreBodyController'

export abstract class UIStoreController {
    abstract bodyController: UIStoreBodyController
    abstract headerCoinsContainer: HTMLDivElement
}
